import React from 'react'
import Ink from 'react-ink';
import { addQuantity, removeQuantity, removeReceiptline, setSelectedLine } from '../actions/receiptActions';
import { processFunction } from '../actions/keyFunctionActions';
import { getArticle } from '../actions/dataActions';
import { connect } from 'react-redux'
import * as types from '../constants/Types'
import * as functions from '../constants/Functions'
import * as right from '../constants/Rights'
import { hasRight } from '../actions/rightsActions'
import PropTypes from 'prop-types'

class ReceiptLine extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectLine = this.handleSelectLine.bind(this);
    this.handleAddQuantity = this.handleAddQuantity.bind(this);
    this.handleRemoveQuantity = this.handleRemoveQuantity.bind(this);
    this.handleRemoveReceiptLine = this.handleRemoveReceiptLine.bind(this);
    this.handleEditConfiguration = this.handleEditConfiguration.bind(this);
  }

  handleSelectLine() {
    this.props.setSelectedLine(this.props.lineid);
  }

  handleAddQuantity() {
    document.activeElement.blur();

    if (((this.props.quantity < -0.5 || this.props.quantity >= 0.5)
      || (this.props.quantity === -0.5))
      && this.props.hasRight(right.POS_CANCELLINE, true)) {
      this.props.addQuantity(this.props.lineid);
    }
  }

  handleRemoveQuantity() {
    document.activeElement.blur();
    
    if (((this.props.quantity >0.5 || this.props.quantity <= -0.5)
      || (this.props.quantity === 0.5))
      && this.props.hasRight(right.POS_CANCELLINE, true)) {
      this.props.removeQuantity(this.props.lineid);
    }
  }

  handleRemoveReceiptLine() {
    if (this.props.hasRight(right.POS_CANCELLINE, true)) {
      this.props.removeReceiptline(this.props.lineid);
    }
  }

  handleEditConfiguration() {
    this.props.processFunction(functions.Configuration);
  }

  render() {
    const price = this.props.price.toFixed(2).toString().replace('.', ',');
    let touchTapHTML;
    if (this.props.linetype !== types.PAYMENT_LINE && this.props.editable) {
      touchTapHTML = (this.handleSelectLine);
    }

    let configurationDescription = '';
    let i = 0;
    if (this.props.configuration) {
      this.props.configuration.forEach(conf => {
        if (i > 0) {
          configurationDescription = `${configurationDescription}, `;
        }

        var splitted = conf.ConfigurationStepValueDescription.split(':');
        if(splitted.length === 2) {
          configurationDescription = `${configurationDescription}${splitted[1]}`;          
        } else {
          configurationDescription = `${configurationDescription}${conf.ConfigurationStepValueDescription}`;
        }

        i++;
      });
    }

    let addButton;
    let minusButton;
    let configurationButton;
    if (!this.props.blackbox
      && this.props.linetype !== types.SUBTOTAL_LINE
      && this.props.linetype !== types.DISCOUNT_LINE
      && (!this.props.productionprinted || this.props.productionprinted === 0)
      && this.props.hasRight(right.POS_CANCELLINE, false)) {
      addButton = (<button onClick={this.handleAddQuantity} className="expanderbutton plusbutton">
        <i className="plus icon"></i><Ink />
      </button>)
      minusButton = (<button onClick={this.handleRemoveQuantity} className="expanderbutton minbutton">
        <i className="minus icon"></i><Ink />
      </button>)

      if (this.props.detailsOpen
        && this.props.configuration.length > 0) {
        configurationButton = (<button onClick={this.handleEditConfiguration} className="expanderbutton minbutton">
          <i className="configure icon"></i><Ink />
        </button>)
      }
    }
    let lineStyle = {
      backgroundColor: '#fff'
    }

    var hideLineDetails = false;
    if (this.props.linetype === types.SUBTOTAL_LINE) {
      if (!this.props.simpleSeparator){
        lineStyle.borderBottom = '1px solid #475358'
        lineStyle.borderTop = '1px solid #475358'
        lineStyle.backgroundColor = '#CAD9DD';
      }
      else
      {
        lineStyle.borderTop = '5px dashed #E6EDEF';
        lineStyle.height = "5px";
        hideLineDetails = true;
      }
    }

    var hideLine = this.props.linetype === types.RECEIPT_INFO_LINE && !this.props.printReceiptInfo;
    
    let quantity = (<div className="quantity"></div>);
    if (this.props.linetype === types.ARTICLE_LINE) {
      quantity = `${this.props.quantity}x`
    }

    let expander;
    if (this.props.selected  
      && ((this.props.detailView && this.props.detailsOpen) || (!this.props.detailView && !this.props.detailsOpen)) 
      && this.props.postype !== types.POSTYPE_PRODUCTIONKIOSK  
      && this.props.linetype !== types.RECEIPT_INFO_LINE
      && this.props.hasRight(right.POS_CANCELLINE, false)) {
      expander = (<div id="expander" className="expander">
        {addButton}
        {minusButton}
        {configurationButton}
        <button onClick={this.handleRemoveReceiptLine} className="expanderbutton deletebutton">
          <i className="remove icon"></i><Ink />
        </button>
      </div>);

      lineStyle = {
        backgroundColor: '#e6edef'
      }
    }

    let discountStyle = {
      fontSize: '12px'
    }
    const discounts = [];
    if (this.props.discount !== null) {
      let id = 1;
      this.props.discount.map(d => {
        discounts.push({
          id: id,
          description: d.Description,
          price: d.Price.toFixed(2).replace('.', ',')
        });
        id++;
        return '';
      })
    }

    const article = this.props.weight > 0 ? this.props.getArticle(this.props.itemid) : null;
    
    return (
      <div key={this.props.lineid} className="linewrapper" style={lineStyle} hidden={hideLine}>
        <div key={this.props.lineid} onClick={touchTapHTML} ref="receiptline" className="receiptLine">
          <table className="contenttable">
            <tbody>
              <tr hidden={hideLineDetails}>
                <td className="quantity">{quantity}</td>
                <td className="description">
                  {this.props.description}&nbsp;
                    <label className="configurationDescription">{configurationDescription}</label>
                </td>
                <td className="price">
                  {this.props.linetype === types.RECEIPT_INFO_LINE ? '' : price}
                </td>
              </tr>
              {article && 
              <tr>
                <td>&nbsp;</td>
                <td colSpan="2" style={discountStyle}>{`${(this.props.weight / 1000.0).toFixed(3).replace('.',',')}kg x ${article.SalesPrice.toFixed(2).replace('.',',')}/kg`}</td>
              </tr>}
              {discounts.map(d =>
                <tr key={d.id}>
                  <td className="quantity"></td>
                  <td><label style={discountStyle}>{d.description}</label></td>
                  <td className="price">{d.price}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {expander}
      </div>
    )
  }
}

ReceiptLine.propTypes = {
  quantity: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  configuration: PropTypes.array,
  discount: PropTypes.array.isRequired,
  price: PropTypes.number.isRequired,
  lineid: PropTypes.number,
  itemid: PropTypes.number,
  linetype: PropTypes.number,
  editable: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  detailView: PropTypes.bool,
  weight: PropTypes.number,
  simpleSeparator: PropTypes.bool,
  keyid: PropTypes.number,
  productionprinted: PropTypes.number
}

function mapStateToProps(state) {
  return {
    blackbox: state.generalState.licenses.blackbox && state.generalState.hasBlackbox,
    detailsOpen: state.modalState.receiptModal.show,
    postype: state.generalState.posType,
    printReceiptInfo: state.generalState.printReceiptInfo
  }
}

export default connect(mapStateToProps, {
  addQuantity,
  removeQuantity,
  removeReceiptline,
  setSelectedLine,
  processFunction,
  hasRight,
  getArticle
})(ReceiptLine)



// WEBPACK FOOTER //
// src/components/ReceiptLine.jsx